// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as JsxRuntime from "react/jsx-runtime";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function PaymentElementShimmer$Shimmer(props) {
  let __classname = props.classname;
  let __classname_value = __classname !== undefined ? __classname : "";
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: `relative
      ` + __classname_value + `
    before:absolute before:inset-0
    before:-translate-x-full
    before:animate-[shimmer_1s_infinite]
    before:bg-gradient-to-r
    before:px-1
    before: rounded
    before:from-transparent before:via-slate-200 before:to-transparent overflow-hidden w-full`
  });
}

let Shimmer = {
  make: PaymentElementShimmer$Shimmer
};

function PaymentElementShimmer$SavedPaymentShimmer(props) {
  return JsxRuntime.jsx(PaymentElementShimmer$Shimmer, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            className: "w-10 h-5 rounded-full m-3 bg-white bg-opacity-70"
          }),
          JsxRuntime.jsx("div", {
            className: "my-auto w-24 h-2 rounded m-3 bg-white bg-opacity-70"
          })
        ],
        className: "flex flex-row my-auto"
      }),
      className: "animate-pulse w-full h-12 rounded bg-slate-200"
    })
  });
}

let SavedPaymentShimmer = {
  make: PaymentElementShimmer$SavedPaymentShimmer
};

function PaymentElementShimmer$SavedPaymentCardShimmer(props) {
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(PaymentElementShimmer$SavedPaymentShimmer, {}),
    className: "Label flex flex-row gap-3 items-end cursor-pointer",
    style: {
      color: match.themeObj.colorPrimary,
      fontSize: "14px",
      fontWeight: "400",
      marginTop: "25px"
    }
  });
}

let SavedPaymentCardShimmer = {
  make: PaymentElementShimmer$SavedPaymentCardShimmer
};

function PaymentElementShimmer(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(PaymentElementShimmer$Shimmer, {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: " w-10 h-5 rounded-full m-3 bg-white bg-opacity-70 "
              }),
              JsxRuntime.jsx("div", {
                className: " my-auto w-24 h-2 rounded m-3 bg-white bg-opacity-70 "
              })
            ],
            className: "flex flex-row  my-auto"
          }),
          className: "animate-pulse w-full h-12 rounded bg-slate-200 "
        })
      }),
      JsxRuntime.jsx(PaymentElementShimmer$Shimmer, {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: " w-10 h-5 rounded-full m-3 bg-white bg-opacity-70 "
              }),
              JsxRuntime.jsx("div", {
                className: " my-auto w-24 h-2 rounded m-3 bg-white bg-opacity-70 "
              })
            ],
            className: "flex flex-row  my-auto"
          }),
          className: "animate-pulse w-full h-12 rounded bg-slate-200 "
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(PaymentElementShimmer$Shimmer, {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: " w-10 h-5 rounded-full m-3 bg-white bg-opacity-70 "
                  }),
                  JsxRuntime.jsx("div", {
                    className: " my-auto w-24 h-2 rounded m-3 bg-white bg-opacity-70 "
                  })
                ],
                className: "flex flex-row  my-auto"
              }),
              className: "animate-pulse w-auto  h-12 rounded  bg-slate-200"
            })
          }),
          JsxRuntime.jsx(PaymentElementShimmer$Shimmer, {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: " w-10 h-5 rounded-full m-3 bg-white bg-opacity-70 "
                  }),
                  JsxRuntime.jsx("div", {
                    className: " my-auto w-24 h-2 rounded m-3 bg-white bg-opacity-70 "
                  })
                ],
                className: "flex flex-row  my-auto"
              }),
              className: "animate-pulse w-auto h-12 rounded  bg-slate-200"
            })
          })
        ],
        className: "flex flex-row gap-4 w-full"
      })
    ],
    className: "flex flex-col gap-4"
  });
}

let make = PaymentElementShimmer;

export {
  Shimmer,
  SavedPaymentShimmer,
  SavedPaymentCardShimmer,
  make,
}
/* jotai Not a pure module */
